/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// Fonts
import 'typeface-alegreya'
import 'typeface-alegreya-sans'

// Styles
import './src/styles/main.scss'
import './src/styles/blog.scss'
import './src/styles/bloghome.scss'
import './src/styles/404.scss'

// Code Highlighting theme
import 'prism-theme-night-owl'

// // Latex CSS
// import 'katex/dist/katex.min.css'

// Service Worker PWA updater
export const onServiceWorkerUpdateReady = () => {
  const answer = window.confirm(
    `This application has been updated. ` +
      `Reload to display the latest version?`
  )

  if (answer === true) {
    window.location.reload()
  }
}
